import {Component, OnDestroy, OnInit,OnChanges,SimpleChanges} from '@angular/core';
import {OperationsService} from 'src/app/core/services/operations.service';
import {Observable, Subject} from 'rxjs';
import {ServicePathsSettings} from 'src/app/core/configuration/service-paths-settings';
import {PropertiesSettings} from 'src/app/core/configuration/properties-settings';
import {Controparte} from 'src/app/common/models/controparte';
import {CreazionePraticaStoreService} from '../../../services/creazione-pratica-store.service';
import {Parte} from 'src/app/common/models/parte';
import {takeUntil} from 'rxjs/operators';
import { refreshContropartePrimaria } from '../../../utils/controparti-utils';

@Component({
  selector: 'app-list-controparti',
  templateUrl: './list-controparti.component.html',
  styleUrls: ['./list-controparti.component.css']
})
export class ListContropartiComponent implements OnInit,OnChanges, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  msgEmpty: string;

  labelButton = 'Disassocia'

  disabled = false;

  controparti: Controparte[] = [];

  optionsList: { hasDetailsAnagrafica: boolean, controparte: Controparte }[] = [];


  activeIndex: number;

  editParte: Controparte;

  private componentDestroyed$: Subject<void> = new Subject<void>();

  currentTab: String = "ASSOCIATIVA";

  editing = false;

  indexContropartePrimaria: number;


  constructor(private operations: OperationsService, private creazionePraticaStoreService: CreazionePraticaStoreService) {
  }

  ngOnInit() {
    this.creazionePraticaStoreService.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(controparti => {
      this.optionsList = [];
      if (controparti && controparti.length > 0) {
        this.controparti = controparti;
        controparti.forEach(element => {
          const option = {hasDetailsAnagrafica: false, controparte: element}
          this.optionsList.push(option)
        });
        if(this.optionsList.length === 1){
          this.optionsList[0].controparte.primario = true;
        }
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
  }

  openDetail(option: { hasDetailsAnagrafica: boolean, controparte: Controparte }, indice: number) {
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
    } else {
      this.activeIndex = undefined;
    }

  }

  disassocia(option: { hasDetailsAnagrafica: boolean, controparte: Controparte }, indice: number) {
    this.controparti = this.controparti.filter(controparte => controparte.parte.id !== option.controparte.parte.id)
    this.creazionePraticaStoreService.setControparti(this.controparti);
    this.creazionePraticaStoreService.save();
  }

  retrieveParte(controparte: Controparte, option: { hasDetailsAnagrafica: boolean, controparte: Controparte }) {
    this.editParte = controparte;
    if (controparte) {
      option.controparte = controparte;
      this.editParte = undefined;
    }
  }

  retrieveControparte(controparteRetrieved: Controparte){
    let contropartiFiltred = refreshContropartePrimaria(this.controparti,controparteRetrieved);
    this.controparti = contropartiFiltred;
    this.creazionePraticaStoreService.setControparti(this.controparti);
    this.creazionePraticaStoreService.save();
    this.editing = false;
    this.activeIndex = undefined;
  }

}
